import { Component, Input } from '@angular/core';
import { DefaultFormDialogComponent } from '../../../../shared/message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { Override } from '../../../../shared/app-decorators';
import { ICountryExtended, ILocationExtended } from '../../../../../type_definitions/datatypes';
import { FormlyType, GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { LOV_COUNTRY, LovService } from '../../../../shared/services/lov.service';

@Component({
  selector: 'bp-profiles-locations-dialog',
  templateUrl: '../../../../shared/message/dialogs/default-form-dialog.html'
})
export class BPProfilesLocationsDialogComponent extends DefaultFormDialogComponent {
  @Input() public model:ILocationExtended = <any>{};

  private currencyField:IExtraFieldConfigurationObject;
  private stateField:IExtraFieldConfigurationObject;
  private countryField:IExtraFieldConfigurationObject;

  constructor(
    private lovService:LovService,
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    protected validateService:GaValidateService,
    protected translationService:TranslationService
  ) {
    super(validateService, translationService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit():void {
    super.ngOnInit();

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private fillFields():void {
    this.formlyService.fillField(this.countryField, this.lovService.list(LOV_COUNTRY));
    this.loadStatesList();
    this.loadCurrenciesList();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';
    const halfWidthClass:string = 'col-sm-6';

    return [
      this.formlyService.anInput('name')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .isRequired()
        .build(),
      this.formlyService.aGroup('addressGroup')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .withFields([
          this.formlyService.anInput('address')
            .withoutWrapper()
            .withWrapperClass(`${fullWidthClass} margin-bottom-xs`)
            .build(),
          this.formlyService.anInput('zipCode')
            .withoutWrapper()
            .withWrapperClass('col-sm-3')
            .withValueClass('margin-bottom-xs')
            .build(),
          this.formlyService.anInput('city')
            .withoutWrapper()
            .withWrapperClass('col-sm-9')
            .withValueClass('margin-bottom-xs')
            .build(),
          this.stateField = this.formlyService.aSelect2('state')
            .withFormat(this.formattingService.formatState)
            .withoutWrapper()
            .withWrapperClass(`${fullWidthClass} margin-bottom-xs`)
            .withHideExpression(() => !(<ICountryExtended>this.model.country).hasState)
            .build(),
          this.countryField = this.formlyService.aSelect2('country')
            .withoutWrapper()
            .withWrapperClass(`${fullWidthClass} margin-bottom-xs`)
            .withFormat(this.formattingService.formatCountry)
            .onChange(() => {
              this.loadCurrenciesList();
              this.loadStatesList();
            })
            .build()
        ])
        .build(),
      this.formlyService.anInput('homePage')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.aGroup('phoneGroup')
        .withoutWrapper()
        .withFields([
          this.formlyService.anInput('telephoneNumber')
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .build(),
          this.formlyService.anInput('faxNumber')
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .build()
        ])
        .build(),
      this.formlyService.anInput('companyRegisteredName')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.aGroup('vatGroup')
        .withoutWrapper()
        .withFields([
          this.formlyService.anInput('vatNumber')
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .build(),
          this.formlyService.anInput('companyRegistrationNumber')
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .build()
        ])
        .build(),
      this.formlyService.aGroup('infoGroup')
        .withoutWrapper()
        .withFields([
          this.formlyService.aDateInput('incorporationDate')
            .withFormat(this.formattingService.formatDate)
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .build(),
          this.formlyService.aGroup('creditLimitGroup')
            .withWrapperClass(halfWidthClass)
            .withLabelClass(fullWidthClass)
            .withValueClass(fullWidthClass)
            .withFields([
              this.formlyService.anInput('creditLimit')
                .withInputType(FormlyType.NUMBER)
                .withoutWrapper()
                .withWrapperClass('col-sm-6')
                .withExtraOptions({
                  templateOptions: {
                    min: 0
                  }
                })
                .build(),
              this.currencyField = this.formlyService.aSelect('currency')
                .withoutWrapper()
                .withWrapperClass('col-sm-6')
                .withFormat(this.formattingService.formatCurrencyL)
                .build()
            ])
            .build()
        ])
        .build(),
      this.formlyService.aCheckbox('active')
        .withoutWrapper()
        .build()
    ];
  }

  private loadStatesList():void {
    if ((<ICountryExtended>this.model.country)?.hasState) {
      this.formlyService.fillField(this.stateField, this.lovService.list(`state-${(<ICountryExtended>this.model.country)?.id}`));
    }
  }

  private loadCurrenciesList():void {
    if ((<ICountryExtended>this.model.country)?.id) {
      this.formlyService.fillField(this.currencyField, this.lovService.list(`localcurrency-${(<ICountryExtended>this.model.country)?.id}`));
    }
  }
}